import React, { FC } from 'react';
import Truncate from 'react-truncate';

import ImgixWrapper from '@common/components/ImgixWrapper';
import { Link } from 'shared-routing';
import { DiscountBanner, FromPrice } from '../Price';
import { EventsGridProps } from './EventsGrid.types';
import {
  ITEM_MARGIN,
  Event,
  EventsGridWrapper,
  ImagePlaceholder,
  EventName,
  ImageWrapper,
} from './EventsGrid.styles';

/**
 * @deprecated Use list/listitem
 */
export const EventsGrid: FC<EventsGridProps> = ({ items = [], columns = 4, route }) => {
  const imageAspectRatio = 2 / 3;
  const initialWidth = 1440 / columns - 2 * ITEM_MARGIN;
  const initialHeight = Math.floor(initialWidth * imageAspectRatio);

  return (
    <EventsGridWrapper>
      {items.map((item) => (
        <Event columns={columns} key={item.id}>
          <Link route={route} params={{ id: String(item.id) }}>
            {item.imageGallery?.length ? (
              <ImageWrapper>
                <DiscountBanner discount={item.discount} />
                <ImgixWrapper
                  src={item.imageGallery[0].url}
                  width={initialWidth}
                  height={initialHeight}
                  sizes="auto"
                  imgixParams={{
                    ar: '2:3',
                  }}
                  alt={item.name}
                />
              </ImageWrapper>
            ) : (
              <ImagePlaceholder ratio={imageAspectRatio} />
            )}
            <EventName>
              <Truncate trimWhitespace lines={2}>
                {item.name}
              </Truncate>
            </EventName>
            <FromPrice price={item.price} discount={item.discount} />
          </Link>
        </Event>
      ))}
    </EventsGridWrapper>
  );
};
